// extracted by mini-css-extract-plugin
module.exports = {"service-container":"style_service-container__2MxPe"};